import Header from "../home/header"
import ContactHero from "./contactHero"
import Contactform from './contactform'
import Footer from '../home/footer.js'
const contactpage=()=>{
    return(
        <>
            <Header/>
            <ContactHero/>
            <Contactform/>
            <Footer/>
        </>
    )
}
export default contactpage